<template>
    <v-card class="transparent" flat>
        <v-card-actions>
            <v-btn class="indigo text-capitalize" dark to="/masa-sanggah">Dalam Masa Sanggah</v-btn>
            <v-btn class="indigo text-capitalize" dark to="/hasil-tender">Hasil Tender</v-btn>
        </v-card-actions>
        <v-card-text>
            <v-data-table :headers="table.headers" :items="table.items" :items-per-page="15" no-data-text="HASIL TENDER">
                <template v-slot:item.metodePemilihan="{item}">
                    {{ getMetodePemilihan(item.metodePemilihan) }}
                </template>
                <!-- Penyedia -->
                <template v-slot:item.penyedia="{item}">
                    {{ item.vendor }} / No.Reg {{ item.noRegistrasi }}
                </template>
            </v-data-table>
        </v-card-text>
    </v-card>
</template>


<script>

const axios = require('axios').default;
const apiUrl = process.env.VUE_APP_ROOT_API
import { itemsMetodePemilihan } from './../lib/viewTenderLib'
import { getValueItem, } from './../lib/viewLib'
export default {
    data() {
        return {
            table: {
                headers: [
                    { text: "Kode Paket", value: "kode", class: "light-blue lighten-2 subtitle-1 font-weight-bold" },
                    { text: "Nama Paket", value: "nama", class: "light-blue lighten-2 subtitle-1 font-weight-bold" },
                    { text: "Metode Pemilihan", value: "metodePemilihan", class: "light-blue lighten-2 subtitle-1 font-weight-bold" },
                    { text: "Penyedia", value: "penyedia", class: "light-blue lighten-2 subtitle-1 font-weight-bold" }
                ],
                items: []
            },
            allListMetodePemilihan: itemsMetodePemilihan,
        }

    }, // data


    mounted() {
        axios.get(`${apiUrl}/api/lelang/hasil-tender`)
        .then( (response) => {
            this.table.items = response.data;
        }).catch( (error) => {
            console.error(error);
        });

    }, // mounted
    methods: {
        getMetodePemilihan: function(val) {
        return val ? getValueItem(this.allListMetodePemilihan, val) : ''
        },
    }

}

</script>